import { getSettings } from '../../util/getSettings';
const settings = getSettings(['century', 'settings']);

const defaultMobileLocFilters = {
    relativeUrl: '',
    selectedState: settings.stateName,
    selectedMetro: settings.metroName,
    selectedCity: settings.cityName,
    metros: settings.metros,
    cities: settings.metroName.length ? settings.cities.filter((city) => city.MetroName === settings.metroName) : settings.cities,
}

const mobileLocFilters = (state = defaultMobileLocFilters, action) => {
    switch(action.type) {
        case 'SET_RELATIVE_URL':
            return {...state, relativeUrl: action.url}
        case 'SET_SELECTED_STATE':
            return {...state, selectedState: action.selectedState}
        case 'SET_SELECTED_METRO':
            return {...state, selectedMetro: action.selectedMetro}
        case 'SET_SELECTED_CITY':
            return {...state, selectedCity: action.selectedCity}
        case 'UPDATE_METROS':
            return {...state, metros: action.metros}
        case 'UPDATE_CITIES':
            return {...state, cities: action.cities}
        case 'RESET_MOBILE_LOC_FILTERS': 
            return defaultMobileLocFilters
        default:
            return state
    }
}

export default mobileLocFilters